import {BoidGroup} from "../../boids/model";
import {BoidAssignment} from "@common-core/coat-operational-hierarchy-appsync-model";

export const groupBoidAssignments = (
  groups: BoidGroup<BoidAssignment[]>[],
  assignment: BoidAssignment
): BoidGroup<BoidAssignment[]>[] => {
  const existingGroup = groups.find(
    group => group.type === assignment.businessOperationType.toUpperCase()
  );

  if (existingGroup) {
    existingGroup.boids?.push(assignment);
  } else {
    groups.push({
      type: assignment.businessOperationType.toUpperCase(),
      boids: [assignment]
    });
  }

  return groups;
};
